import { render, staticRenderFns } from "./Adsense.vue?vue&type=template&id=1dd79fbe&scoped=true"
import script from "./Adsense.vue?vue&type=script&lang=js"
export * from "./Adsense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd79fbe",
  null
  
)

export default component.exports